// src/pages/Bullying.js
import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "../styles/Bullying.css"; 
import Navbar from "../components/Navbar"; 

const PAGE_SIZE = 5;
const LS_KEY = (userId) => `bullyingProgress:${userId}`;

const Bullying = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const [responses, setResponses] = useState({});
  const [questions, setQuestions] = useState([]);
  const [userData, setUserData] = useState(null);
  const [showSidebar, setShowSidebar] = useState(false);
  const navigate = useNavigate();

  // 🔹 Guardar en localStorage
  const persistLocal = (draft = {}) => {
    if (!userData?._id) return;
    const payload = {
      responses: draft.responses ?? responses,
      currentStep: draft.currentStep ?? currentStep,
      updatedAt: new Date().toISOString(),
      version: 1,
    };
    localStorage.setItem(LS_KEY(userData._id), JSON.stringify(payload));
  };

  // 🔹 Obtener usuario y preguntas
  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/users/me`, {
          headers: { Authorization: token },
        });
        setUserData(response.data);
      } catch (error) {
        console.error("Error al obtener usuario:", error);
      }
    };

    fetchUserData();

    setQuestions([
      { question: "Edad:", options: ["Menos de 18 años", "18-22 años", "23-27 años", "Más de 27 años"] },
      { question: "Género:", options: ["Mujer", "Hombre", "No binario", "Prefiero no decirlo"] },
      { question: "Nivel académico:", options: ["Medio superior (bachillerato)", "Licenciatura", "Posgrado", "Otro"] },
      { question: "¿Has recibido información sobre violencia de género, acoso y bullying en tu escuela?", options: ["Sí, de manera frecuente", "Sí, pero muy poco", "No", "No recuerdo"] },
      { question: "¿Consideras que la violencia de género y el bullying son problemas en tu escuela?", options: ["No, son problemas menores", "Ocurren ocasionalmente", "Sí, son problemas frecuentes", "Sí, son problemas muy graves"] },
      { question: "¿Has sido víctima de comentarios ofensivos relacionados con tu género dentro de la escuela?", options: ["Nunca", "Pocas veces", "Frecuentemente", "Siempre"] },
      { question: "¿Alguien te ha tocado sin tu consentimiento dentro de la escuela?", options: ["Nunca", "Pocas veces", "Frecuentemente", "Siempre"] },
      { question: "¿Has sentido miedo de represalias si denuncias una situación de acoso o violencia de género?", options: ["Nunca", "Pocas veces", "Frecuentemente", "Siempre"] },
      { question: "¿Has recibido insinuaciones o mensajes de contenido sexual sin tu consentimiento en la escuela?", options: ["Nunca", "Pocas veces", "Frecuentemente", "Siempre"] },
      { question: "¿Te han presionado para tener una relación sentimental o sexual dentro de la escuela?", options: ["Nunca", "Pocas veces", "Frecuentemente", "Siempre"] },
      { question: "¿Has sido víctima de ciberacoso por parte de alguien de la escuela?", options: ["Nunca", "Pocas veces", "Frecuentemente", "Siempre"] },
      { question: "¿Has sentido inseguridad al caminar dentro de la escuela debido a actitudes o comportamientos de otras personas?", options: ["Nunca", "Pocas veces", "Frecuentemente", "Siempre"] },
      { question: "¿Has sido víctima de burlas o apodos ofensivos dentro de la escuela?", options: ["Nunca", "Pocas veces", "Frecuentemente", "Siempre"] },
      { question: "¿Has sufrido agresiones físicas (empujones, golpes) dentro de la escuela?", options: ["Nunca", "Pocas veces", "Frecuentemente", "Siempre"] },
      { question: "¿Te han excluido intencionalmente de grupos o actividades en la escuela?", options: ["Nunca", "Pocas veces", "Frecuentemente", "Siempre"] },
      { question: "¿Has sentido miedo de asistir a la escuela debido al trato que recibes de tus compañeros?", options: ["Nunca", "Pocas veces", "Frecuentemente", "Siempre"] },
      { question: "¿Alguien ha difundido rumores o mentiras sobre ti con la intención de dañarte dentro de la escuela?", options: ["Nunca", "Pocas veces", "Frecuentemente", "Siempre"] },
      { question: "¿Te han robado o dañado objetos personales dentro de la escuela?", options: ["Nunca", "Pocas veces", "Frecuentemente", "Siempre"] },
      { question: "¿Has presenciado situaciones donde una persona fue acosada o agredida en la escuela?", options: ["Nunca", "Pocas veces", "Frecuentemente", "Siempre"] },
      { question: "Si has presenciado acoso o bullying, ¿qué hiciste?", options: ["Lo ignoré", "Lo reporté a un profesor o autoridad", "Apoyé a la víctima directamente", "No sabía qué hacer"] },
      { question: "¿Has visto a alguien ser excluido o marginado intencionalmente en la escuela?", options: ["Nunca", "Pocas veces", "Frecuentemente", "Siempre"] },
      { question: "¿Te sientes seguro(a) en los espacios comunes de la escuela?", options: ["Siempre", "Casi siempre", "Casi nunca", "Nunca"] },
      { question: "¿Crees que la escuela tiene protocolos eficaces para atender casos de acoso y bullying?", options: ["Sí, totalmente", "En algunos casos", "No han hecho lo suficiente", "No han hecho nada"] },
      { question: "¿Sabes a dónde acudir si sufres o presencias violencia de género o bullying dentro de tu escuela?", options: ["Sí, tengo claro a dónde acudir", "Sí, pero no sé si funciona", "No estoy seguro(a)", "No, no tengo información"] },
      { question: "¿Consideras que los profesores y personal escolar toman en serio los casos de acoso y bullying?", options: ["Sí, completamente", "A veces", "Pocas veces", "No, nunca"] },
      { question: "¿Has recibido apoyo por parte de la escuela en caso de acoso o bullying?", options: ["Sí, y fue eficaz", "Sí, pero no fue suficiente", "No lo he solicitado", "No, nunca"] },
      { question: "¿Has participado en actividades de sensibilización sobre acoso, violencia de género o bullying?", options: ["Sí, varias veces", "Sí, pocas veces", "No, pero me gustaría", "No, nunca"] },
      { question: "¿Consideras que el bullying y la violencia de género han aumentado en tu escuela en los últimos años?", options: ["No, han disminuido", "Se mantienen igual", "Han aumentado un poco", "Han aumentado mucho"] },
      { question: "¿Qué acciones crees que debería tomar tu escuela para prevenir la violencia de género y el bullying?", options: ["Mayor difusión de protocolos y sanciones", "Capacitación a estudiantes y personal", "Creación de un comité especializado", "Mayor seguridad y vigilancia"] },
      { question: "Si tuvieras la oportunidad de proponer una solución contra el bullying y la violencia de género en tu escuela, ¿qué harías?", options: ["Talleres de sensibilización", "Aplicación de sanciones más estrictas", "Creación de grupos de apoyo", "Mayor vigilancia en áreas comunes"] }
    ]);
  }, []);

  // 🔹 Cargar progreso guardado
  useEffect(() => {
    if (!userData?._id) return;
    try {
      const raw = localStorage.getItem(LS_KEY(userData._id));
      if (raw) {
        const saved = JSON.parse(raw);
        if (saved?.responses) setResponses(saved.responses);
        if (Number.isInteger(saved?.currentStep)) setCurrentStep(saved.currentStep);
      }
    } catch (e) {
      console.warn("No se pudo cargar el progreso local:", e);
    }
  }, [userData?._id]);

  const steps = Math.ceil(questions.length / PAGE_SIZE);

  const handleChange = (e, index) => {
    const next = { ...responses, [index]: e.target.value };
    setResponses(next);
    persistLocal({ responses: next });
  };

  const handleNext = () => {
    if (validateStep()) {
      setCurrentStep((prev) => {
        const next = prev + 1;
        persistLocal({ currentStep: next });
        return next;
      });
    }
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handlePrev = () => {
    setCurrentStep((prev) => {
      const next = Math.max(prev - 1, 0);
      persistLocal({ currentStep: next });
      return next;
    });
  };

  const validateStep = () => {
    const start = currentStep * PAGE_SIZE;
    const end = Math.min(start + PAGE_SIZE, questions.length);
    for (let i = start; i < end; i++) {
      if (!responses[i]) {
        alert("Por favor responde todas las preguntas antes de continuar.");
        return false;
      }
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("token");

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/users/submit-bullying`,
        { responses },
        { headers: { Authorization: token } }
      );

      if (response.status === 200) {
        alert("Encuesta enviada exitosamente");
        if (userData?._id) localStorage.removeItem(LS_KEY(userData._id));
        navigate("/dashboard");
      } else {
        alert("Hubo un error al enviar la encuesta");
      }
    } catch (error) {
      console.error("Error al enviar encuesta:", error);
      alert("Error al procesar las respuestas.");
    }
  };

  const handleSaveAndExit = () => {
    persistLocal();
    alert("Progreso guardado localmente. Podrás continuar luego desde este equipo.");
    navigate("/dashboard");
  };

  const toggleSidebar = () => setShowSidebar(!showSidebar);
  const closeSidebar = () => setShowSidebar(false);

  return (
    <>
      <Navbar />

      <div className="dashboard-layout">
        <div className={`sidebar-overlay ${showSidebar ? "show" : ""}`} onClick={closeSidebar}></div>

        <div className={`dashboard-sidebar ${showSidebar ? "show" : ""}`}>
          <div className="sidebar-header">
            <h3>Acoso y Violencia</h3>
          </div>
          <div className="sidebar-menu">
            <div className="survey-progress">
              <div className="progress-info">
                <span>Progreso</span>
                <span>{currentStep + 1}/{steps}</span>
              </div>
              <div className="progress-bar">
                <div className="progress-fill" style={{ width: `${((currentStep + 1) / steps) * 100}%` }} />
              </div>
            </div>
          </div>
          <button 
            className="menu-item return-dashboard"
            onClick={() => {
              if (window.confirm("¿Seguro que deseas regresar? Tus respuestas se han guardado y podrás continuar luego.")) {
                handleSaveAndExit();
              }
            }}
          >
            <i className="bi bi-arrow-left-circle"></i>
            Volver al Dashboard
          </button>
        </div>

        <div className="dashboard-main">
          <div className="survey-container">
            <div className="survey-header">
              <h2>Encuesta sobre Acoso y Violencia Escolar</h2>
              <p className="survey-description">
                Responde con sinceridad para ayudarnos a identificar áreas de mejora en el entorno escolar.
              </p>
              <div className="button-container">
                <button 
                  type="button" 
                  className="nav-button prev"
                  onClick={handleSaveAndExit}
                >
                  <i className="bi bi-floppy"></i>
                  Guardar y salir
                </button>
              </div>
            </div>

            <form className="survey-form" onSubmit={handleSubmit}>
              <div className="questions-group">
                {questions.slice(currentStep * PAGE_SIZE, (currentStep + 1) * PAGE_SIZE).map((questionObj, index) => (
                  <div className="question-card" key={index + currentStep * PAGE_SIZE}>
                    <div className="question-header">
                      <span className="question-number">Pregunta {index + 1 + currentStep * PAGE_SIZE}</span>
                      <p className="question-text">{questionObj.question}</p>
                    </div>
                    <div className="options-grid">
                      {questionObj.options.map((option, optIndex) => (
                        <label 
                          key={optIndex}
                          className={`option-card ${responses[index + currentStep * PAGE_SIZE] === String.fromCharCode(97 + optIndex) ? "selected" : ""}`}
                        >
                          <input
                            type="radio"
                            name={`q${index + currentStep * PAGE_SIZE}`}
                            value={String.fromCharCode(97 + optIndex)}
                            checked={responses[index + currentStep * PAGE_SIZE] === String.fromCharCode(97 + optIndex)}
                            onChange={(e) => handleChange(e, index + currentStep * PAGE_SIZE)}
                            required
                          />
                          <span className="option-text">{option}</span>
                        </label>
                      ))}
                    </div>
                  </div>
                ))}
              </div>

              <div className="navigation-controls">
                {currentStep > 0 && (
                  <button type="button" className="nav-button prev" onClick={handlePrev}>
                    <i className="bi bi-arrow-left"></i> Anterior
                  </button>
                )}
                {currentStep < steps - 1 ? (
                  <button type="button" className="nav-button next" onClick={handleNext}>
                    Siguiente <i className="bi bi-arrow-right"></i>
                  </button>
                ) : (
                  <button type="submit" className="nav-button submit">
                    Finalizar <i className="bi bi-check-circle"></i>
                  </button>
                )}
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Bullying;
